import { useEffect } from 'react';

const PROXIMITY_SELECTOR = '.dashboard-sidebar, .sidebar-brand, .sidebar-profile-header-section, .sidebar-footer, .sidebar-divider';
const PROXIMITY_THRESHOLD = 200; // px — only glow when mouse is this close

export default function useMouseGlow(cardSelector) {
  useEffect(() => {
    let rafId = null;

    const handleMouseMove = (e) => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        const cards = document.querySelectorAll(cardSelector);
        cards.forEach(card => {
          const rect = card.getBoundingClientRect();
          const localX = e.clientX - rect.left;
          const localY = e.clientY - rect.top;

          if (card.matches(PROXIMITY_SELECTOR)) {
            const distX = Math.max(0, Math.max(rect.left - e.clientX, e.clientX - rect.right));
            const distY = Math.max(0, Math.max(rect.top - e.clientY, e.clientY - rect.bottom));
            const dist = Math.sqrt(distX * distX + distY * distY);

            // Always track position, use opacity to fade based on distance
            card.style.setProperty('--mouse-x', `${localX}px`);
            card.style.setProperty('--mouse-y', `${localY}px`);
            const opacity = dist > PROXIMITY_THRESHOLD ? 0 : 1 - (dist / PROXIMITY_THRESHOLD);
            card.style.setProperty('--line-opacity', opacity.toFixed(2));
          } else {
            card.style.setProperty('--mouse-x', `${localX}px`);
            card.style.setProperty('--mouse-y', `${localY}px`);
          }
        });
        rafId = null;
      });
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [cardSelector]);
}
